import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import isEqual from 'lodash.isequal';

import Form from 'react-bootstrap/Form';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Tooltip } from 'react-bootstrap';
import InputTooltip from './InputTooltip';

/**
 * List components.
 *
 * @param {Object} props configs of list
 */
class List extends Component {
  state = {
    list: [...this.props.list],
    selectedValue: []
  };

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.value !== nextProps.value ||
      this.props.valid !== nextProps.valid ||
      this.state.list !== nextState.list
    );
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!isEqual(nextProps.list, prevState.list)) {
      const newList = nextProps.list || [];
      const selectedValue = [];

      if (newList.length === 1 && nextProps.required) {
        const value = nextProps.list[0];
        const event = {
          target: {
            value: value.key
          }
        };
        nextProps.changed(event);
        selectedValue.push(value);
      }

      return {
        list: [...newList],
        selectedValue
      };
    }
    return null;
  }

  handleChange = selected => {
    this.setState({ selectedValue: selected });
    const event = {
      target: {
        value: selected[0]?.key
      }
    };
    this.props.changed(event);
  };

  render() {
    const { intl, label, required, selectedFirstOption, error, tip, valid, list } = this.props;

    let errorMessage = <Form.Text className="empty-field-info">&nbsp;</Form.Text>;

    if (!valid && error) {
      errorMessage = (
        <Form.Text className="error-message-small text-danger">
          <FormattedMessage id={`form.field.${label}.error`} />
        </Form.Text>
      );
    }

    if (selectedFirstOption && list.length > 0 && !this.props.value) {
      this.handleChange(list.slice(0, 1));
    }

    return (
      <Form.Group controlId={label}>
        <Form.Label className={required ? 'field-required' : null}>
          <FormattedMessage id={`form.field.${label}.label`} />
        </Form.Label>
        {tip && (
          <InputTooltip>
            <Tooltip>
              <FormattedMessage id={`form.field.${label}.tip`} />
            </Tooltip>
          </InputTooltip>
        )}
        <Typeahead
          id={`form-field-${label}`}
          isInvalid={!valid}
          onChange={this.handleChange}
          labelKey="value"
          options={list || []}
          placeholder={intl.formatMessage({ id: `form.field.${label}.placeholder` })}
          selected={this.state.selectedValue}
          disabled={list?.length === 0}
          inputProps={required ? { required: true } : {}}
        />
        {errorMessage}
      </Form.Group>
    );
  }
}

export default injectIntl(List);
